<template>
  <transition name="fade">
    <div class="row justify-content-center">
      <div class="col-lg-10 col-md-12 col-sm-12">
        <div class="card" v-if="!fileURL">
          <div class="card-header">
            <h3 class="card-title bold">For Confirmation</h3>
          </div>
          <div class="card-body">
            <Undertaking />
            <div class="icheck-primary d-inline">
              <input type="checkbox" id="agree" v-model="agree" />
              <label for="agree" style="font-size: 16px !important">I agree.</label>
            </div>
          </div>
          <div class="card-footer">
            <button class="btn btn-primary" @click="$emit('back')">
              <i class="fas fa-arrow-left mr-1"></i>Back
            </button>
            <button class="btn btn-success float-right" :disabled="!agree" data-toggle="modal" data-target="#survey-modal">
              Submit Application<i class="fas fa-arrow-right ml-1"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="modal fade" id="modalPad" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">>
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title bold">Borrower's Signature</h5>
            </div>
            <div class="modal-body text-justify">
              <div class="col-12" style="min-width: 200px; max-width:500px;">
                <VueSignaturePad id="signature" width="100%" height="200px" ref="signaturePad" :options="{onBegin: () => {$refs.signaturePad.resizeCanvas()}}" />
                <div class="row text-center">
                  <div class="text-center col-12 mt-2">
                    <span>Sign Above</span> <br><br>
                    <button class="btn btn-outline-primary mx-1" @click="clearSign">Clear</button>
                    <button class="btn btn-outline-primary mx-1" @click="undo">Undo</button>
                  </div>
                </div>
              </div>
              <div class="text-center mt-3" v-if="wacom">
                <button class="btn btn-outline-primary" @click="openWacom">Open Signature Tablet</button>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default mr-auto" @click="closePad">Cancel</button>
              <button type="button" class="btn btn-primary" @click="submitSign">Submit</button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="modalSBLAF" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">>
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title bold">Loan Application Form</h5>
            </div>
            <div class="modal-body text-justify">
              <object :data="fileURL + '#view=FitH'" type="application/pdf" internalinstanceid="9" title="PDF" width="100%" height="100%">
                <div class="alert alert-warning2" role="alert">
                  <span>Your browser isn't supporting embedded pdf files. You can
                    download the file.</span>
                </div>
              </object>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary mr-auto" @click="downloadFile()"><i class="fas fa-download mr-1"></i>Download</button>
              <button type="button" class="btn btn-success" @click="gotoDashboard()">Go to Dashboard<i class="fas fa-arrow-right ml-1"></i></button>
            </div>
          </div>
        </div>
      </div>
      <ModalSurvey :id="'survey-modal'" :borrower_id="formLoan.borrower_id" :application_id="formLoan.application_id" @hide="submitApplication" />
      <SigCaptX @init="initWacom" @switch="switchWacom" @submit="submitWacom" />
    </div>
  </transition>
</template>
<script>
  import ModalSurvey from '@vues/ModalSurvey.vue';
  import Undertaking from '@vues/Undertaking.vue';
  import SigCaptX from '@js/wacom-sdk/SigCaptX.vue';
  export default {
    components: {
      ModalSurvey,
      Undertaking,
      SigCaptX
    },
    props: ["formLoan"],
    data() {
      return {
        agree: false,
        fileURL: null,
        wacom: '',
      };
    },
    created() {},
    computed: {},
    methods: {
      submitWacom(data) {
        this.prepareSignature(data, '#modalWacom');
      },
      openWacom() {
        this.clearSign();
        $('#modalPad').modal('hide');
        $('#modalWacom').modal('show');
      },
      switchWacom() {
        $('#modalPad').modal('show');
      },
      initWacom(val) {
        this.wacom = val;
      },

      gotoDashboard() {
        $('#modalSBLAF').modal('hide');
        this.$router.push('/dashboard');
      },

      apiSubmit(url, form, modal) {
        axios.post(url, form, {
            responseType: "blob"
          })
          .then(response => {
            $(modal).modal('hide');
            this.$emit('load', -1);
            let data = response.data;
            Swal.fire({
              title: "Success",
              icon: "success",
              text: "Thank you for your interest in Small Business Corporation's Program!",
              showCancelButton: false,
              allowEscapeKey: false,
              allowOutsideClick: false,
            }).then((result) => {
              if (result.value) {
                this.fileURL = window.URL.createObjectURL(data);
                $('#modalSBLAF').modal('show');
              }
            });
          }).catch(error => {
            this.$emit('load', -1);
          })
      },

      prepareSignature(data, modal) {
        if (data) {
          this.$emit('load', 1);
          // Create a temporary canvas
          const tempCanvas = document.createElement('canvas');
          const tempCtx = tempCanvas.getContext('2d');

          // Load the signature data into an image
          const img = new Image();
          img.src = data;
          img.onload = () => {
            // Draw the signature image onto the temporary canvas
            tempCanvas.width = img.width;
            tempCanvas.height = img.height;
            tempCtx.drawImage(img, 0, 0);

            // Get image data and analyze for cropping
            const imageData = tempCtx.getImageData(0, 0, tempCanvas.width, tempCanvas.height);
            const {
              top,
              right,
              bottom,
              left
            } = this.getBoundingBox(imageData);

            // Crop the signature
            const croppedCanvas = document.createElement('canvas');
            const croppedCtx = croppedCanvas.getContext('2d');
            croppedCanvas.width = right - left;
            croppedCanvas.height = bottom - top;
            croppedCtx.drawImage(tempCanvas, left, top, croppedCanvas.width, croppedCanvas.height, 0, 0, croppedCanvas.width, croppedCanvas.height);

            // Convert cropped canvas to image data
            const croppedImageData = croppedCanvas.toDataURL();

            const form = {
              application_id: this.formLoan.application_id,
              borrower_id: this.formLoan.borrower_id,
              bus_id: this.formLoan.bus_id,
              bt_code: this.formLoan.bt_code,
              signature: croppedImageData,
            };

            const url = this.formLoan.bt_code == 'BT2020001' ? '/api/sblaf-generate-form-sole' : '/api/sblaf-generate-form';
            this.apiSubmit(url, form, modal);
          }
        } else {
          Swal.fire({
            title: "Warning",
            icon: "warning",
            text: "Signature is required!",
            showCancelButton: false,
            allowEscapeKey: false,
            allowOutsideClick: false,
          })
        }
      },

      submitSign() {
        const {
          isEmpty,
          data
        } = this.$refs.signaturePad.saveSignature();
          this.prepareSignature(data, '#modalPad');
      },
      getBoundingBox(imageData) {
        let top = imageData.height,
          right = 0,
          bottom = 0,
          left = imageData.width;
        for (let y = 0; y < imageData.height; y++) {
          for (let x = 0; x < imageData.width; x++) {
            const index = (y * imageData.width + x) * 4;
            if (imageData.data[index + 3] > 0) {
              if (x < left) left = x;
              if (x > right) right = x;
              if (y < top) top = y;
              if (y > bottom) bottom = y;
            }
          }
        }
        return {
          top,
          right,
          bottom,
          left
        };
      },

      closePad() {
        this.$refs.signaturePad.clearSignature();
        $('#modalPad').modal('hide');
      },

      clearSign() {
        this.$refs.signaturePad.clearSignature()
      },
      undo() {
        this.$refs.signaturePad.undoSignature();
      },
      downloadFile: _.debounce(function() {
        const stamp = new Date().getTime();
        const link = document.createElement("a");
        link.href = this.fileURL;
        link.setAttribute("download", `SBLAF-${stamp}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(this.fileURL);
      }, 333),

      submitApplication: _.debounce(function() {
        if (this.wacom) {
          $('#modalWacom').modal('show');
        } else {
          $('#modalPad').modal('show');
        }
      }, 333),
    },
    mounted() {},
  };
</script>
<style scoped>
  #signature {
    border: 2px solid #dc3545;
    border-radius: 5px;
    background-image: linear-gradient(white, white);
    background-origin: border-box;
    background-clip: content-box, border-box;
  }
</style>